import { trpc } from "@/lib/trpc";
import { useState } from "react";
import { toast } from "sonner";

export function DangerZoneTab() {
	const [confirmation, setConfirmation] = useState("");
	const [password, setPassword] = useState("");
	const utils = trpc.useUtils();

	const resetMutation = trpc.admin.resetData.useMutation({
		onSuccess: () => {
			toast.success("All data has been reset. You can now sync customers from QuickBooks.");
			setConfirmation("");
			setPassword("");
			utils.invalidate();
		},
		onError: (err) => toast.error(err.message),
	});

	const canSubmit = confirmation === "RESET ALL DATA" && password.length > 0;

	return (
		<div className="rounded-lg border-2 border-[#dc2626] bg-white">
			<div className="border-b border-[#fef2f2] px-6 py-4">
				<h2 className="text-sm font-semibold text-[#dc2626]">Danger Zone</h2>
				<p className="mt-1 text-xs text-[#6b7280]">Irreversible actions that affect all data.</p>
			</div>
			<div className="px-6 py-6 space-y-4">
				<div>
					<h3 className="text-sm font-medium text-[#1e1e20]">Reset All Data</h3>
					<p className="mt-1 text-xs text-[#6b7280]">
						Deletes all customers, documents, extractions, and invoices. Preserves user accounts,
						QBO connection, and settings. Use this before syncing customers from QuickBooks for
						production setup. Blocked if any invoice has already been pushed to QuickBooks — void
						those in QBO first.
					</p>
				</div>
				<div className="space-y-3">
					<div>
						<label
							htmlFor="reset-confirm"
							className="block text-xs font-medium text-[#6b7280] mb-1"
						>
							Type <span className="font-mono text-[#dc2626]">RESET ALL DATA</span> to confirm
						</label>
						<input
							id="reset-confirm"
							type="text"
							value={confirmation}
							onChange={(e) => setConfirmation(e.target.value)}
							placeholder="RESET ALL DATA"
							className="h-9 w-full rounded border border-[#d1d5db] bg-white px-3 text-sm text-[#1e1e20] placeholder:text-[#e5e7eb] focus:border-[#dc2626] focus:outline-none focus:ring-2 focus:ring-[#dc2626]/20"
						/>
					</div>
					<div>
						<label
							htmlFor="reset-password"
							className="block text-xs font-medium text-[#6b7280] mb-1"
						>
							Re-enter your password to confirm this is you
						</label>
						<input
							id="reset-password"
							type="password"
							autoComplete="current-password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className="h-9 w-full rounded border border-[#d1d5db] bg-white px-3 text-sm text-[#1e1e20] focus:border-[#dc2626] focus:outline-none focus:ring-2 focus:ring-[#dc2626]/20"
						/>
					</div>
					<button
						type="button"
						onClick={() => {
							if (canSubmit) {
								resetMutation.mutate({ confirmation: "RESET ALL DATA", password });
							}
						}}
						disabled={!canSubmit || resetMutation.isPending}
						className="h-9 rounded-md bg-[#dc2626] px-4 text-sm font-medium text-white hover:bg-[#b91c1c] disabled:opacity-50 disabled:cursor-not-allowed"
					>
						{resetMutation.isPending ? "Resetting..." : "Reset Data"}
					</button>
				</div>
			</div>
		</div>
	);
}
